import {RecurrenceAdapterOptions, RecurrenceRuleModel} from 'calendar/models/recurrence.model';
import {RecurrenceAdapterResult} from 'calendar/services/recurrence-adapter-result';

export class RecurrenceAdapter {
    constructor(private options: RecurrenceAdapterOptions) { }

    assign(rule: RecurrenceRuleModel): RecurrenceAdapterResult {
        return new RecurrenceAdapterResult(rule, this.options);
    }
}